export default __webpack_public_path__ + "static/media/aug_gjafabref_litil-min.f3070d96.jpg";